module.exports = __webpack_public_path__ + "img/changeAllocation-2.e6d3048.png";